export default __webpack_public_path__ + "static/sanjayRakesh5-1eb53a1e61df81ab9d92ec7b4ae6b9f1.jpg";